import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailSettingsService } from './email-settings.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-email-settings',
  templateUrl: './email-settings.component.html',
  styleUrls: ['./email-settings.component.css']
})
export class EmailSettingsComponent implements OnInit {
  emailForm: FormGroup;
  public submitted: boolean = false;
  constructor(private fb: FormBuilder, private router: Router, private emailSettingsService: EmailSettingsService, public toasr: ToastrService) {
    this.emailForm = this.fb.group({
      contactPersonEmail: ['', [Validators.required, Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdCeo: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdSales: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdNonSales: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdService: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      emailIdSpares: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      alternateEmailId: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_insurance_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_finance_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_bestvalue_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_accessories_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      non_sales_service_info_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
      p_s_email: ['', [Validators.pattern('^[a-z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$')]],
    });
  }

  outletId: any = '';
  ngOnInit() {
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.outletId = loginResponse.data?.user?.outlet_id;
      }
    }
    this.getOutletDetails();
  }
  get f() { return this.emailForm.controls; }

  back() {
    this.router.navigate(['/target-report']);
  }

  getOutletDetails() {
    let queryParams = this.outletId;
    this.emailSettingsService.getOutletDetails(queryParams).subscribe((res: any) => {
      if (res.body.responseCode === 200) {
        let outletDetails = res.body.data;
        let outletEmails = outletDetails.outlet_emails;
        const emailMap: any = {};
        outletEmails.forEach((item: any) => {
          emailMap[item.email_name] = item.email;
        });

        this.emailForm.patchValue({
          contactPersonEmail: outletDetails.contact_person_email || '',
          emailIdCeo: emailMap['ceo'] || '',
          emailIdSales: emailMap['sales_person'] || '',
          emailIdNonSales: outletDetails.non_sales_email || '',
          emailIdService: emailMap['service'] || '',
          emailIdSpares: emailMap['spares'] || '',
          alternateEmailId: emailMap['alternate_email'] || '',
          non_sales_insurance_email: outletDetails.non_sales_insurance_email || '',
          non_sales_finance_email: outletDetails.non_sales_finance_email || '',
          non_sales_bestvalue_email: outletDetails.non_sales_bestvalue_email || '',
          non_sales_accessories_email: outletDetails.non_sales_accessories_email || '',
          non_sales_service_info_email: outletDetails.non_sales_service_info_email  || '',
          p_s_email: emailMap['p_and_s'] || ''
        });
      }
    });
  }

  updateEmailDetails() {
    this.submitted = true;
    if (this.emailForm.invalid) {
      return;
    }
    let formValues = this.emailForm.value;
    let emailData = {
      contactPersonEmail: formValues.contactPersonEmail,
      emailIdNonSales: formValues.emailIdNonSales,
      non_sales_insurance_email: formValues.non_sales_insurance_email,
      non_sales_finance_email: formValues.non_sales_finance_email,
      non_sales_bestvalue_email: formValues.non_sales_bestvalue_email,
      non_sales_accessories_email: formValues.non_sales_accessories_email,
      non_sales_service_info_email: formValues.non_sales_service_info_email,
      emails: [
        { "ceo": formValues.emailIdCeo },
        { "sales_person": formValues.emailIdSales },
        { "spares": formValues.emailIdSpares },
        { "service": formValues.emailIdService },
        { "alternate_email": formValues.alternateEmailId },
        {"p_and_s": formValues.p_s_email}
      ]
    }
    this.emailSettingsService.updateEmailDetails(emailData).subscribe((res: any) => {
      if (res.body.responseCode === 200) {
        this.toasr.success('Email details updated successfully!');
        this.getOutletDetails();
      } else {
        this.toasr.error('Email details update failed!');
      }
    });
  };
}
